import 'whatwg-fetch';
import _Vue from 'vue'; // <-- notice the changed import
import { Api, } from './self-serve-client';
import { Api as JourneyFeatureApi, } from './ui-client';

export interface SelfServeApiPluginOptions {
	baseUrl: string;
}

export function SelfServeApiPlugin(Vue: typeof _Vue, options?: SelfServeApiPluginOptions): void {
	const api = new Api({
		baseUrl: options?.baseUrl,
		securityWorker() {
			const xsrfToken = getCookieValue('XSRF-TOKEN');

			return {
				headers: {
					'X-XSRF-TOKEN': xsrfToken,
				},
			};
		},
	});

	const journeyFeatureApi = new JourneyFeatureApi({
		baseUrl: options?.baseUrl,
		securityWorker() {
			const xsrfToken = getCookieValue('XSRF-TOKEN');

			return {
				headers: {
					'X-XSRF-TOKEN': xsrfToken,
				},
			};
		},
	});

	const apiRequest = api.request;
	// Wrapper around the request, so that the actual response is thrown in an error, and not the whole API response
	// The catch handlers aren't expecting that, and easier to fixup here
	// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
	api.request = (...args) => apiRequest(...args).catch((error) => Promise.reject(error?.error ?? error));

	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	(Vue as any).selfServeApi = api.api;
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	Vue.prototype.$selfServeApi = api.api;

	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	(Vue as any).journeyFeatureApi = journeyFeatureApi.api;
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
	Vue.prototype.$journeyFeatureApi = journeyFeatureApi.api;
}

function getCookieValue(cookieName: string) {
	const allCookies = decodeURIComponent(document.cookie).split(/;\s*/);
	for (let i = 0; i < allCookies.length; i++) {
		const cookie = allCookies[i];
		if (cookie.startsWith(cookieName + '=')) {
			return cookie.substring(cookieName.length + 1);
		}
	}
	return '';
}

declare module 'vue/types/vue' {
	interface Vue {
		$selfServeApi: Api<unknown>['api'];
	}
	interface VueConstructor {
		selfServeApi: Api<unknown>['api'];
	}
	interface Vue {
		$journeyFeatureApi: JourneyFeatureApi<unknown>['api'];
	}
	interface VueConstructor {
		journeyFeatureApi: JourneyFeatureApi<unknown>['api'];
	}
}
